module.exports = __webpack_public_path__ + "static/media/sickle.ff0c37ee.svg";